const Icons = {
  accountNotVerified: require('../assets/account_not_verified.png'),
  accountVerified: require('../assets/account_verified.png'),
  accountonProcess: require('../assets/account_process.png'),
  arrowLeftBlack: require('../assets/arrow_left_black.png'),
  arrowLeftRed: require('../assets/arrow_left_red.png'),
  arrowRightBlack: require('../assets/arrow_right_black.png'),
  arrowRightStripeBlack: require('../assets/arrow_right_stripe_black.png'),
  arrowRightStripeOrangeSmall: require('../assets/arrow_right_stripe_orange_small.png'),
  dropdownBlack: require('../assets/dropdown_black.png'),
  arrowRightOrange: require('../assets/arrow_right_orange.png'),
  arrowRightBrown: require('../assets/arrow_right_brown.png'),
  chevronRightBlack: require('../assets/chevron_right_black.png'),
  chatHelpOrange: require('../assets/chat_help_orange.png'),
  checkWhite: require('../assets/check_white.png'),
  crossBlack: require('../assets/cross_black.png'),
  downloadOrange: require('../assets/download_orange.png'),
  exclamationMarkCirclePink: require('../assets/exclamation_mark_circle_pink.png'),
  flipLg: require('../assets/flip_lg.png'),
  contactCircleBlue: require('../assets/contact_circle_blue.png'),
  warningOrange: require('../assets/warning_orange.png'),
  document: require('../assets/document.png'),
  dangerRed: require('../assets/danger_red.png'),
  info: require('../assets/info.png'),
  infoCircle: require('../assets/info_circle.png'),
  instagramGray: require('../assets/instagram_gray.png'),
  key: require('../assets/key.png'),
  profileOut: require('../assets/profile-signout.png'),
  progress: require('../assets/progress.png'),
  tiktokGray: require('../assets/tiktok_gray.png'),
  twitterGray: require('../assets/twitter_gray.png'),
  sendMoney: require('../assets/home_send_money.png'),
  searchGrey: require('../assets/search_grey.png'),
  viaSms: require('../assets/via_sms.png'),
  viaWa: require('../assets/via_wa.png'),
  globeBlack: require('../assets/globe_black.png'),
  globeWhite: require('../assets/globe_white.png'),
  youtubeGray: require('../assets/youtube_gray.png'),
  iconRightWhiteSmall: require('../assets/icon_right_white_small.png'),
  indicatorAlert: require('../assets/indication/indication_alert.png'),
  indicatorBullet: require('../assets/indication/indication_bullet.png'),
  indicatorChecked: require('../assets/indication/indication_checked.png'),
  indicatorInfo: require('../assets/indication/indication_information.png'),
  indicatorNotVerified: require('../assets/indication/shield_not_verified.png'),
  indicatorVerified: require('../assets/indication/shield_verified.png'),
  indicatorWarning: require('../assets/indication/shield_warning.png'),
  dot: require('../assets/dot.png'),
  addBalance: require('../assets/add_balance.png'),
  addBalanceActive: require('../assets/add_balance_active.png'),
  mBayar: require('../assets/m_bayar.png'),
  iconPolygon: require('../assets/icon_polygon.png'),
  chevronRightBtnFilled: require('../assets/buttons/chevron-right-btn-filled.png'),
  chevronLeftBtnOutlined: require('../assets/buttons/chevron-left-btn-outlined.png'),
  checkBtnFilled: require('../assets/buttons/check-btn-filled.png'),
  divider: require('../assets/divider.png'),
  verifyIdentity: require('../assets/verify_identity.png'),
  emailOrange: require('../assets/email_orange.png'),
  checkCircle: require('../assets/check_circle.png'),
  envelope: require('../assets/envelope.png'),
};

export default Icons;
